import type { HerWeekEvent } from '../../api'

const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London' })
const time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/London' })

function dayKey(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10)
}

interface Props {
  events: HerWeekEvent[]
}

export default function HerWeekAhead({ events }: Props) {
  if (events.length === 0) {
    return <div className="empty-state">Nothing on her calendar this week — or it isn't shared yet.</div>
  }

  // Build seven days starting today
  const today = new Date()
  const days: { iso: string; ts: number; events: HerWeekEvent[] }[] = []
  for (let i = 0; i < 7; i++) {
    const d = new Date(today.getTime() + i * 86400000)
    const iso = dayKey(d.getTime())
    days.push({ iso, ts: d.getTime(), events: [] })
  }
  for (const ev of events) {
    const k = dayKey(ev.start_at)
    const day = days.find(d => d.iso === k)
    if (day) day.events.push(ev)
  }

  return (
    <div className="her-week">
      {days.map(d => (
        <div key={d.iso} className="her-week-day">
          <div className="day">{dayName.format(new Date(d.ts))}</div>
          <div>
            {d.events.length === 0
              ? <span className="muted italic">—</span>
              : d.events.map((e, i) => (
                <div key={i}>
                  <span className="mono muted">{time.format(new Date(e.start_at))}</span> {e.title}
                </div>
              ))
            }
          </div>
        </div>
      ))}
    </div>
  )
}
